export function formPath(...strings: string[]) {
  return strings.length > 0 ? strings[0] + strings.slice(1, strings.length).reduce((acc, s) => acc + '/' + s, '') : ''
}
export function param(str: string) {
  return ':' + str;
}
export function query(key: string) {
  return function (val: string) { let o = {}; o[key] = val; return o; }
}